import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=6fc5b63a&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"
import style0 from "./Layout.vue?vue&type=style&index=0&id=6fc5b63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc5b63a",
  null
  
)

export default component.exports